import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Calculator } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function IncomeTaxLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const fmt = (d) => {
    if (!d) return "Something went wrong.";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
    return String(d);
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); setError(""); setSubmitting(true);
    try {
      await login(email, password, "income_tax");
      navigate("/income-tax", { replace: true });
    } catch (err) {
      setError(fmt(err.response?.data?.detail));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex" data-testid="incometax-login-page" style={{ background: "#052e2b" }}>
      {/* Left brand panel */}
      <div className="hidden lg:flex flex-col justify-center flex-1 px-16 text-white">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-14 h-14 bg-amber-400 rounded-sm flex items-center justify-center">
            <Calculator size={32} weight="duotone" className="text-emerald-950" />
          </div>
          <div>
            <h1 className="text-4xl font-black tracking-tighter" style={{ fontFamily: "Chivo, sans-serif" }}>LokTech Tax Pro</h1>
            <p className="text-amber-300 text-xs font-bold tracking-[0.3em] uppercase">Income Tax Module</p>
          </div>
        </div>
        <p className="text-emerald-100/80 max-w-md text-sm leading-relaxed">
          ITR filing, TDS returns, advance tax aur client management — sab ek hi
          secure module mein. Authorized users only.
        </p>
      </div>

      {/* Right form panel */}
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md bg-white rounded-sm shadow-2xl p-8 sm:p-10">
          <div className="lg:hidden flex items-center gap-3 mb-6">
            <div className="w-10 h-10 bg-amber-400 rounded-sm flex items-center justify-center">
              <Calculator size={22} weight="duotone" className="text-emerald-950" />
            </div>
            <div>
              <h1 className="text-xl font-black tracking-tighter text-slate-900">LokTech Tax Pro</h1>
              <p className="text-[10px] font-bold tracking-widest text-emerald-700 uppercase">Income Tax Module</p>
            </div>
          </div>
          <h2 className="text-2xl font-black tracking-tighter text-slate-900 mb-1" style={{ fontFamily: "Chivo, sans-serif" }}>Income Tax Sign In</h2>
          <p className="text-slate-500 text-xs mb-4">Authorized Income Tax users only — access is granted by the Super Admin.</p>
          <div className="grid grid-cols-2 gap-3 mb-6">
            <button
              type="button"
              data-testid="it-module-choice-gst"
              onClick={() => navigate("/login")}
              className="flex items-center justify-center border-2 border-slate-300 text-slate-700 hover:bg-slate-50 rounded-sm px-3 py-2.5 text-sm font-bold transition-colors"
            >
              ← GST Software
            </button>
            <div data-testid="it-module-choice-it" className="flex items-center justify-center border-2 border-emerald-800 bg-emerald-800 text-white rounded-sm px-3 py-2.5 text-sm font-bold">
              Income Tax
            </div>
          </div>
          {error && <div className="bg-red-50 border border-red-200 text-red-700 text-sm p-3 rounded-sm mb-4" data-testid="it-login-error">{error}</div>}
          <form onSubmit={handleSubmit} className="space-y-5">
            <div><Label>Email</Label><Input type="email" data-testid="it-login-email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" required /></div>
            <div><Label>Password</Label><Input type="password" data-testid="it-login-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter password" required /></div>
            <Button type="submit" data-testid="it-login-submit" disabled={submitting} className="w-full bg-emerald-800 hover:bg-emerald-900 text-white font-semibold py-3">
              {submitting ? "Please wait..." : "Sign In to Income Tax"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
